"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.map.js");
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _usePrefixCls = require("../_utils/hooks/usePrefixCls");
var _teaComponent = require("@tencent/tea-component");
var _PlusIcon = _interopRequireDefault(require("../Icon/icons/PlusIcon"));
var Tag = function Tag(props) {
  var className = props.className,
    style = props.style,
    items = props.items,
    onClose = props.onClose,
    onAdd = props.onAdd,
    otherTags = props.otherTags,
    onOtherClose = props.onOtherClose,
    onOtherAdd = props.onOtherAdd,
    otherAddText = props.otherAddText,
    responsive = props.responsive;
  var prefixCls = (0, _usePrefixCls.usePrefixCls)('tag');
  var classes = (0, _classnames.default)("".concat(prefixCls, "__list"), className, {
    responsive: responsive
  });
  var closeHandle = function closeHandle(item) {
    if (typeof onClose === 'function') {
      onClose(item);
    }
  };
  var closeOtherHandle = function closeOtherHandle(item) {
    if (typeof onOtherClose === 'function') {
      onOtherClose(item);
    }
  };
  return /*#__PURE__*/_react.default.createElement("ul", {
    className: classes,
    style: style
  }, otherTags === null || otherTags === void 0 ? void 0 : otherTags.map(function (item, index) {
    return /*#__PURE__*/_react.default.createElement("li", {
      key: index
    }, /*#__PURE__*/_react.default.createElement(_teaComponent.Tag, {
      onClose: item.undeletable || !onClose ? undefined : function () {
        return closeOtherHandle(item);
      },
      className: "".concat(prefixCls, "__tag")
    }, item.text));
  }), !otherTags && onOtherAdd && /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement(_teaComponent.Button, {
    type: "weak",
    className: (0, _classnames.default)('ma-t-tag__btn', "".concat(prefixCls, "__add")),
    onClick: onOtherAdd
  }, /*#__PURE__*/_react.default.createElement(_PlusIcon.default, {
    size: 12,
    style: {
      marginRight: 4
    }
  }), /*#__PURE__*/_react.default.createElement("span", null, otherAddText))), items === null || items === void 0 ? void 0 : items.map(function (item, index) {
    return /*#__PURE__*/_react.default.createElement("li", {
      key: index
    }, /*#__PURE__*/_react.default.createElement(_teaComponent.Tag, {
      onClose: item.undeletable || !onClose ? undefined : function () {
        return closeHandle(item);
      },
      className: "".concat(prefixCls, "__tag")
    }, item.text));
  }), onAdd && /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement(_teaComponent.Button, {
    type: "weak",
    className: (0, _classnames.default)('ma-t-tag__btn', "".concat(prefixCls, "__add")),
    onClick: onAdd
  }, /*#__PURE__*/_react.default.createElement(_PlusIcon.default, {
    size: 12,
    style: {
      marginRight: 4
    }
  }), /*#__PURE__*/_react.default.createElement("span", null, "\u6807\u7B7E"))));
};
var _default = Tag;
exports.default = _default;